import React from 'react';

export const generateFAQSchema = data => {
  if (!data) return;
  const schema = data.map(z => {
    const question = z.question?.question;
    const answer = z.answer?.childMarkdownRemark?.html;
    return (
      question &&
      answer && {
        '@type': 'Question',
        name: question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: answer.replace(/(<([^>]+)>)/gi, ''),
        },
      }
    );
  });
  return schema;
};

export const generateBreadcrumbSchema = data => {
  if (!data) return;

  const schema = data.map((listItem, index) => {
    return {
      '@type': 'ListItem',
      position: index + 1,
      name: listItem.title,
      ...(listItem.url && { item: `https://www.servicetitan.com${listItem.url}` }),
    };
  });

  return schema;
};

export const getRobot = (indexable, slug, isThankYouPage) => {
  //Thank you page - default (no selection in Contentful)
  if (isThankYouPage) {
    if (indexable === false || indexable === null) {
      return <meta name="ROBOTS" content="NOINDEX, NOFOLLOW" />;
    }
  }

  //PPC Landing page - default (no selection in Contentful)
  if (slug && (slug.startsWith('go/') || slug.startsWith('/go'))) {
    if (indexable === false || indexable === null) {
      return <meta name="ROBOTS" content="NOINDEX, FOLLOW" />;
    }
  }

  //Indexable || no chosen value
  if (indexable === true || indexable === null) {
    return <meta name="ROBOTS" content="INDEX, FOLLOW" />;
  }

  //Non-Indexable
  if (!indexable) {
    return <meta name="ROBOTS" content="NOINDEX, NOFOLLOW" />;
  }
};
